module.exports = "/images/Serbia.png?219bbccc3de21288be320c3865fb89f7";